
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { cleanExistingSlug } from '@/lib/slugUtils';

/**
 * Component to handle redirects from old malformed URLs to clean ones
 * This ensures backward compatibility for bookmarked or shared links
 */
export const URLRedirectHandler = () => {
  const { seoUrl } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (seoUrl) {
      // Check if the URL contains encoded characters that need cleaning
      const hasEncodedChars = seoUrl.includes('%') || 
                             seoUrl.includes(',') || 
                             seoUrl.includes('&') || 
                             seoUrl.includes(' ');

      if (hasEncodedChars) {
        // Clean the URL and redirect
        const cleanedSlug = cleanExistingSlug(seoUrl);
        console.log('Redirecting from malformed URL:', seoUrl, 'to:', cleanedSlug);
        navigate(`/events/${cleanedSlug}`, { replace: true });
      }
    }
  }, [seoUrl, navigate]);

  return null; // This component doesn't render anything
};
